import React from 'react'
import PropTypes from 'prop-types'

import Icon from '../icon'
import styles from './SettingsCard.module.scss'

/** White card with an icon + title header, used for every settings section. */
export default function SettingsCard({
  icon,
  title,
  description,
  actions,
  id,
  children,
}) {
  return (
    <section className={styles.card} id={id}>
      {title && (
        <div className={styles.titleRow}>
          {icon && <Icon name={icon} className={styles.titleIcon} />}
          <h2 className={styles.title}>{title}</h2>
        </div>
      )}
      {description && <p className={styles.description}>{description}</p>}
      {children}
      {actions && <div className={styles.actions}>{actions}</div>}
    </section>
  )
}

SettingsCard.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.node,
  description: PropTypes.node,
  actions: PropTypes.node,
  id: PropTypes.string,
  children: PropTypes.node,
}
